{
  "title": "Приложения",
  "intro": "Программы, которые CloudServer ставит и ведёт на ваших серверах или в своей инфраструктуре. Каждое изменение — ревизия, к любой можно откатиться; ручные правки файлов видны как расхождение.",
  "tabsLabel": "Разделы приложений",
  "tabs": {
    "catalogue": "Каталог",
    "installed": "Установленные"
  },
  "catalogue": {
    "label": "Каталог приложений",
    "emptyTitle": "Каталог пуст",
    "emptyText": "На этой установке пока нет приложений.",
    "install": "Установить",
    "installAria": "Установить «{{name}}»",
    "installed": "Установлено: {{count}}",
    "free": "Бесплатно",
    "perMonth": "{{price}} в месяц",
    "unavailable": {
      "bundle_missing": "Недоступно: нет подписанного пакета для этой установки.",
      "bundle_unverified": "Недоступно: подпись пакета не сходится.",
      "no_provider_plane": "Недоступно: нужна инфраструктура CloudServer, она ещё не подключена.",
      "driver_not_built": "Появится на следующих этапах.",
      "no_autopilot": "Недоступно: прибору нужен Автопилот, а он на этой установке не настроен."
    },
    "freePlusServers": "Бесплатно + серверы по цене провайдера"
  },
  "placement": {
    "provider": "В инфраструктуре CloudServer",
    "customer-vm": "На вашем сервере",
    "customer-appliance": "Управляемый прибор в проекте",
    "hybrid": "Гибрид"
  },
  "category": {
    "core": "Основа",
    "network": "Сети",
    "vpn": "VPN",
    "apps": "Приложения",
    "monitoring": "Мониторинг",
    "dns": "DNS и домены",
    "provider_service": "Сервис CloudServer",
    "example": "Пример"
  },
  "installed": {
    "label": "Установленные приложения",
    "emptyTitle": "Ничего не установлено",
    "emptyText": "Выберите приложение в каталоге — CloudServer поставит его на сервер через роль Автопилота и будет следить за его файлами.",
    "toCatalogue": "Открыть каталог",
    "columns": {
      "name": "Приложение",
      "where": "Где",
      "state": "Состояние",
      "revision": "Ревизия",
      "ownership": "Управление",
      "autonomy": "Автопилот"
    },
    "plane": "Инфраструктура CloudServer",
    "revision": "{{applied}} из {{desired}}",
    "notApplied": "не применена",
    "appliance": "Свой сервер: {{server}}"
  },
  "phase": {
    "pending": "Ожидает",
    "applying": "Применяется",
    "ready": "Работает",
    "drift": "Изменено вручную",
    "error": "Ошибка",
    "removing": "Удаляется"
  },
  "ownership": {
    "managed": "Ведёт CloudServer",
    "co-managed": "Совместно",
    "customer": "Ведёте вы"
  },
  "ownershipHint": {
    "managed": "Источник правды — панель. Ручные правки файлов приложения — расхождение: их видно, и их можно вернуть как было.",
    "co-managed": "Панель ведёт только свои файлы и поля, остальное — ваше.",
    "customer": "Источник правды — вы. Автопилот только наблюдает и предлагает; меняет лишь по вашей карточке."
  },
  "autonomy": {
    "observe": "Наблюдает",
    "suggest": "Предлагает",
    "approve": "Действует после одобрения",
    "policy": "Действует в рамках политики"
  },
  "autonomyHint": {
    "observe": "Только отмечает расхождения в журнале.",
    "suggest": "Предлагает изменение карточкой; вы применяете его сами.",
    "approve": "Готовит изменение и выполняет его, когда вы одобрите карточку.",
    "policy": "Сам исправляет то, что разрешено политикой (например, возвращает свои файлы после ручной правки). Если на сервере открыт терминал — всё равно спрашивает."
  },
  "autonomySource": {
    "instance": "задано для приложения",
    "project": "как в проекте",
    "organization": "как в организации",
    "package": "по умолчанию"
  },
  "projectAutonomy": {
    "label": "Автономия Автопилота в проекте",
    "inherit": "Как в организации",
    "saved": "Автономия проекта сохранена"
  },
  "reasons": {
    "applied": "Ревизия применена",
    "previous_revision": "Работает предыдущая ревизия",
    "not_applied": "Ревизия не применена",
    "in_sync": "Файлы совпадают",
    "no_error": "Без ошибок",
    "manual_edit": "Изменено вручную",
    "customer_change": "Файлы изменены вами",
    "verify_failed": "Проверка не прошла, изменение откатано",
    "foreign_files": "По пути файла — чужой файл",
    "helper_refused": "Помощник на сервере отказал",
    "not_installed": "На сервере не установлено",
    "server_state_missing": "На сервере пропало состояние приложения",
    "plane_failed": "Сервис не создан",
    "ready": "Сервис готов",
    "provisioning": "Сервис создаётся",
    "frozen": "Руки прочь: Автопилот ничего не менял",
    "observe_only": "Автопилот только наблюдает",
    "presence": "На сервере открыт терминал",
    "autonomy": "Так велит автономия",
    "ownership": "Приложение ведёте вы",
    "customer_file": "Это файл клиента",
    "changed_since_card": "Файл изменился после того, как карточка была создана",
    "plan_changed": "Правка уже не та, что на карточке",
    "unsupported": "Панель не может править этот файл",
    "not_in_bundle": "Приложение не меняет этот файл",
    "requires_os": "Эта версия ОС сервера ниже той, с которой работает приложение",
    "requires_arch": "Архитектура сервера не поддерживается",
    "requires_repository": "Репозиторий приложения не поддерживает эту версию ОС или архитектуру сервера",
    "requires_repository_reachable": "Репозиторий приложения не ответил — попробуйте позже",
    "requires_no_docker": "На сервере уже есть Docker, поставленный не через панель",
    "requires_no_docker_repo": "На сервере уже подключён репозиторий Docker не через панель",
    "requires_unmet": "Сервер не подходит приложению",
    "package_not_applied": "Приложение ещё не применено на сервере",
    "not_managed": "Это не контейнер панели: для ваших контейнеров отдельное действие",
    "listing_changed": "Список образов изменился — проверьте снова",
    "engine_stopped": "Docker остановлен",
    "engine_removed": "Docker удалён с сервера",
    "no_container": "Такого контейнера нет",
    "container_invalid": "Недопустимое имя контейнера",
    "restart_failed": "Перезапуск не удался",
    "restart_rolled_back": "Служба не поднялась после перезапуска: файл возвращён, служба перезапущена снова",
    "op_failed": "Действие не удалось",
    "unknown_action": "Сервер не знает такого действия",
    "remove_failed": "Удаление не удалось, файлы на месте",
    "purge_failed": "Данные удалить не удалось",
    "no_restart_step": "У приложения нет шага перезапуска",
    "engine_not_running": "Docker не поднялся",
    "resources_creating": "Создаются ресурсы прибора",
    "resources_deleting": "Ресурсы прибора удаляются",
    "rolled_back": "Созданное удалено",
    "enrolment_timeout": "Помощник на новом сервере так и не ответил",
    "protection_failed": "Не удалось включить защиту сервера",
    "server_gone": "Сервер пропал у провайдера",
    "resource_failed": "Ресурс не создан",
    "appliance_changed": "Изменено у провайдера",
    "managed_appliance": "Это управляемый прибор: меняется только через приложение",
    "take_over_unsupported": "Забрать себе можно только сервер, на котором работает приложение",
    "appliance_not_ready": "Прибор ещё не готов",
    "bad_key": "Помощник не принял ключ",
    "prefix": {
      "provider": "Провайдер отказал ({{reason}})",
      "bundle": "Приложение не установилось на сервере: {{reason}}",
      "delete": "Удаление не прошло: {{reason}}"
    }
  },
  "checks": {
    "package_version": "версия Docker",
    "service_disabled": "автозапуск службы docker",
    "engine_removed": "Docker (удалён)",
    "tailscale": {
      "service_disabled": "автозапуск службы tailscaled",
      "logged_out": "узел вышел из сети Tailscale",
      "tailscale_down": "Tailscale остановлен (tailscale down)",
      "routes_changed": "объявленные подсети",
      "exit_node_changed": "выходной узел",
      "ssh_changed": "Tailscale SSH",
      "forwarding_off": "пересылка IP",
      "tailscale_removed": "Tailscale (удалён)"
    }
  },
  "problems": {
    "required": "Заполните поле.",
    "type": "Значение не подходит по типу.",
    "enum": "Выберите один из вариантов.",
    "min_length": "Не короче {{limit}} символов.",
    "max_length": "Не длиннее {{limit}} символов.",
    "pattern": "Недопустимые символы.",
    "minimum": "Не меньше {{limit}}.",
    "maximum": "Не больше {{limit}}.",
    "max_items": "Не больше {{limit}} строк.",
    "unknown": "Такого поля у приложения нет."
  },
  "form": {
    "secretStored": "Сохранён. Оставьте пустым, чтобы не менять.",
    "listHint": "По одному значению в строке.",
    "labelsHint": "Через запятую: ключ=значение.",
    "choose": "Выберите…",
    "ranges": {
      "label": "Диапазон CIDR",
      "add": "Добавить",
      "addManual": "Добавить диапазон вручную",
      "manual": "Диапазоны, добавленные вручную",
      "remove": "Убрать {{range}}",
      "invalid": "Это не диапазон CIDR, например 192.168.10.0/24."
    }
  },
  "wizard": {
    "title": "Установка: {{name}}",
    "stepsLabel": "Шаги установки",
    "step": "Шаг {{n}} из {{total}}",
    "next": "Далее",
    "back": "Назад",
    "install": "Установить",
    "steps": {
      "connect": "Подключение",
      "inputs": "Параметры",
      "server": "Сервер",
      "review": "Проверка",
      "resources": "Ресурсы и стоимость"
    },
    "oauth": "Вход в {{provider}}",
    "oauthSoon": "Вход через стороннюю учётную запись появится вместе с первыми приложениями, которым он нужен. Токены будут храниться у нас в зашифрованном виде.",
    "deviceSoon": "Подтверждение кодом устройства появится вместе с первыми приложениями, которым оно нужно.",
    "serverLead": "Приложение ставится через возможность Автопилота «Управление приложениями»: помощник на сервере принимает только пакеты, подписанные нами, и пишет только свои файлы.",
    "serverLabel": "Сервер",
    "roleMissing": "Нужно «Управление приложениями»",
    "notRunning": "Сервер выключен",
    "installedHere": "Уже установлено",
    "releaseUnsupported": "Приложение не поддерживает {{release}}",
    "repositoryUnavailable": "Репозиторий {{name}} не поддерживает {{release}}",
    "releaseUntested": "Репозиторий поддерживает {{release}}; на этой версии мы ещё не проверяли",
    "releaseUnchecked": "Версию системы проверим на сервере перед установкой",
    "setRole": "Включить роль на вкладке «Автопилот»",
    "noServers": "Ни на одном сервере проекта не включено «Управление приложениями». Включите его на вкладке «Автопилот» сервера и выполните команду роли на сервере.",
    "ownershipLegend": "Кто ведёт приложение",
    "review": {
      "inputs": "Параметры",
      "server": "Сервер",
      "where": "Где",
      "price": "Цена",
      "priceNote": "Приложения пока не тарифицируются — учитывается только использование.",
      "secret": "скрыто",
      "connect": "Подключение",
      "appliance": "Новый сервер в проекте — управляемый прибор ({{names}})",
      "resources": "Серверы у провайдера",
      "resourcesNote": "Провайдер выставляет счёт за сервер прибора, как за любой ваш сервер; в расходах он идёт под этим приложением."
    },
    "done": "«{{name}}» установлено",
    "stopped": "Установка остановлена",
    "provisioning": "«{{name}}»: создаём сервер прибора — это займёт несколько минут",
    "noNetworks": {
      "text": "В проекте нет частной сети — прибору нечего открывать. Создайте сеть или поставьте приложение клиентом на сервер.",
      "create": "Создать сеть",
      "asClient": "Поставить как клиент на сервер"
    }
  },
  "instance": {
    "back": "Все приложения",
    "tabsLabel": "Разделы приложения",
    "tabs": {
      "state": "Состояние",
      "revisions": "Ревизии",
      "journal": "Журнал",
      "settings": "Настройки"
    },
    "on": "на {{server}}",
    "check": "Проверить",
    "checked": "Файлы проверены",
    "managedNotice": "Файлы этого приложения ведёт CloudServer. Ручные изменения будут обнаружены и показаны как расхождение.",
    "applianceNotice": "Управляемый прибор. Ручные изменения будут перезаписаны.",
    "frozen": "Руки прочь: Автопилот ничего не меняет в этом приложении. Ваши собственные изменения выполняются.",
    "serverFrozen": "Руки прочь на сервере: Автопилот ничего не меняет на нём.",
    "lease": "Автопилот меняет {{name}}, ещё около {{minutes}} мин",
    "leaseBy": "Идёт изменение {{name}}: {{verb}}",
    "presence": "На сервере открыт терминал (людей: {{count}}) — изменения Автопилота ждут карточки.",
    "drift": {
      "title": "Изменено вручную",
      "text": "На сервере вручную изменили: {{files}}. Изменения панели остановлены, чтобы не перезаписать правку.",
      "revert": "Вернуть как было",
      "reverted": "Возвращено как было"
    },
    "customerChange": "Файлы отличаются от панели: {{files}}. Приложение ведёте вы, это ваше состояние.",
    "error": "Последнее изменение не применилось: {{reason}}",
    "stopped": "Изменение остановлено: {{reason}}",
    "proposals": {
      "title": "Автопилот предлагает",
      "revert": "Вернуть как было: {{files}}",
      "apply": "Применить ревизию {{revision}}",
      "why": "Почему карточка: {{reason}}",
      "approve": "Одобрить",
      "reject": "Отклонить",
      "approved": "Карточка одобрена",
      "rejected": "Карточка отклонена",
      "patch": "Изменить файл {{path}}",
      "patchHow": "Это ваш файл: Автопилот меняет его только по этой карточке. При нажатии он сохранит копию файла, внесёт ровно эту правку, проверит результат и вернёт копию, если проверка не пройдёт. Если файл изменится раньше, правка не применится — появится новая карточка.",
      "created": "Файла пока нет — он будет создан.",
      "tooBig": "Файл слишком большой, чтобы показать правку здесь (больше 32 КБ).",
      "diffLabel": "Правка файла {{path}}",
      "unchanged": "… строк без изменений: {{count}}",
      "applyPatch": "Применить правку",
      "applyRestart": "Применить и перезапустить",
      "applyNoRestart": "Применить без перезапуска ({{later}})",
      "restartNotice": "Служба перезапустится, чтобы прочитать файл.",
      "restartRollback": "Если после перезапуска служба не поднимется, Автопилот вернёт копию файла и перезапустит её снова.",
      "appliedRestarted": "Правка применена, служба перезапущена",
      "appliedLater": "Правка применена; вступит в силу при следующем запуске"
    },
    "widgets": {
      "empty": "Сервер ещё не прислал состояние.",
      "noValue": "—"
    },
    "files": {
      "title": "Файлы на сервере",
      "checked": "проверено {{time}}",
      "never": "ещё не проверялись",
      "states": {
        "ok": "совпадает",
        "drift": "изменён",
        "missing": "удалён",
        "unknown": "неизвестно"
      }
    },
    "outputs": "Выходы",
    "conditions": "Условия",
    "actions": {
      "run": "Выполнить",
      "confirm": "Выполнить «{{name}}»?",
      "done": "«{{name}}» выполнено"
    },
    "revisions": {
      "label": "Ревизии",
      "columns": {
        "number": "№",
        "reason": "Что",
        "state": "Итог",
        "actor": "Кто",
        "when": "Когда"
      },
      "reasons": {
        "install": "Установка",
        "configure": "Настройка",
        "action": "Действие «{{detail}}»",
        "rollback": "Откат к ревизии {{detail}}",
        "revert": "Возврат после ручной правки"
      },
      "states": {
        "pending": "Ожидает",
        "applied": "Применена",
        "failed": "Не применена",
        "rolled_back": "Откатана",
        "superseded": "Заменена",
        "proposed": "Предложена"
      },
      "rollback": "Откатиться",
      "rollbackAria": "Откатиться к ревизии {{number}}",
      "rollbackTitle": "Откатиться к ревизии {{number}}?",
      "rollbackText": "Будет создана новая ревизия с параметрами ревизии {{number}} и применена на сервере. Секреты останутся текущими.",
      "rolledBack": "Откат применён",
      "current": "текущая"
    },
    "journal": {
      "label": "Журнал изменений",
      "empty": "Записей пока нет.",
      "verbs": {
        "install": "установка",
        "configure": "настройка",
        "action": "действие",
        "rollback": "откат",
        "revert": "возврат файлов",
        "remove": "удаление",
        "check": "проверка",
        "drift": "ручная правка",
        "freeze": "руки прочь",
        "unfreeze": "руки прочь снято",
        "autonomy": "автономия",
        "proposal": "карточка",
        "approve": "карточка одобрена",
        "reject": "карточка отклонена",
        "patch": "правка файла клиента",
        "adopt": "файл передан панели",
        "release": "файл возвращён клиенту",
        "provision": "создание ресурса",
        "deprovision": "удаление ресурсов",
        "take_over": "забрано себе",
        "restore": "возврат прибора как было"
      },
      "outcomes": {
        "success": "готово",
        "failed": "ошибка",
        "refused": "остановлено",
        "pending": "ждёт"
      },
      "actors": {
        "person": "Человек в панели",
        "api_key": "API-ключ",
        "assistant": "Ассистент",
        "autopilot": "Автопилот",
        "ssh": "Кто-то по SSH",
        "provider": "Кто-то у провайдера"
      },
      "revision": "ревизия {{revision}}"
    },
    "settings": {
      "configure": "Параметры",
      "save": "Сохранить и применить",
      "saved": "Новая ревизия применена",
      "ownership": "Кто ведёт приложение",
      "autonomy": "Автономия Автопилота",
      "autonomyInherit": "Как в проекте",
      "autonomyAdmins": "Менять автономию могут администраторы.",
      "autonomySaved": "Автономия сохранена",
      "freeze": "Руки прочь",
      "freezeHint": "Автопилот не будет ничего менять в этом приложении, даже в рамках политики. Ваши собственные изменения выполняются.",
      "frozen": "Руки прочь включено",
      "unfrozen": "Руки прочь выключено",
      "remove": "Удалить приложение",
      "removeText": "Файлы приложения будут удалены с сервера. Журнал изменений сохранится.",
      "removeButton": "Удалить",
      "removeOverwrite": "Удалить и файлы, изменённые вручную",
      "removed": "«{{name}}» удалено",
      "removeData": "Удалить и данные приложения",
      "removeDataWarning": "Данные приложения будут удалены без возможности вернуть."
    },
    "customerFiles": {
      "title": "Файлы клиента",
      "lead": "Файлы, которые нужны приложению, но принадлежат вам: у них нет каталога для своих файлов. Пока файл ваш, Автопилот меняет его только по карточке. Переданный панели файл приложение ведёт само: держит в нём свои ключи и считает их ручную правку расхождением, а остальное в файле остаётся вашим.",
      "states": {
        "pending": "ждёт правки",
        "ok": "правка на месте",
        "changed": "изменён вами",
        "drift": "ключи приложения изменены вручную",
        "missing": "файла нет",
        "unsupported": "панель не может его править",
        "unknown": "не проверялся",
        "off": "не используется: выключено в настройках"
      },
      "adopted": "ведёт панель",
      "customers": "ваш файл",
      "adopt": "Передать файл под управление панели",
      "release": "Вернуть файл себе",
      "adoptedDone": "Файл передан панели",
      "released": "Файл снова ваш"
    }
  },
  "server": {
    "title": "Приложения на сервере",
    "lead": "Что CloudServer поставил на этот сервер. Помощник с «Управлением приложениями» пишет только свои файлы и останавливается, если их меняли вручную.",
    "none": "На этом сервере приложений нет.",
    "install": "Установить приложение",
    "roleMissing": "Чтобы ставить приложения, включите на вкладке «Автопилот» возможность «Управление приложениями».",
    "freeze": "Руки прочь для всего сервера",
    "freezeHint": "Автопилот ничего не меняет на этом сервере.",
    "frozen": "Руки прочь включено для сервера",
    "unfrozen": "Руки прочь для сервера выключено",
    "appMissing": "Этого приложения на сервере нет.",
    "openApp": "Открыть приложение"
  },
  "docker": {
    "noStatus": "Состояние Docker ещё не прочитано. Нажмите «Проверить».",
    "stopped": "Docker остановлен",
    "stoppedText": "Контейнеры на этом сервере не работают. Причину покажет журнал службы docker на вкладке «Автопилот»; частые — переполненный диск и ошибка в /etc/docker/daemon.json.",
    "restartEngine": "Перезапустить Docker",
    "restartEngineLead": "Служба Docker перезапустится. Контейнеры на минуту остановятся; те, у кого есть политика перезапуска, поднимутся сами.",
    "engineRestarted": "Docker перезапущен",
    "rootWarning": "Участник группы docker фактически получает права root на этом сервере. Добавляйте в неё только тех, кому доверяете root.",
    "rootWarningUsers": "В группе docker: {{users}}. Каждый из них фактически получает права root на этом сервере.",
    "owner": {
      "managed": "панели",
      "customer": "ваш"
    },
    "state": {
      "running": "работает",
      "restarting": "перезапускается",
      "exited": "остановлен",
      "created": "создан",
      "paused": "на паузе",
      "dead": "сломан"
    },
    "containers": {
      "title": "Контейнеры",
      "lead": "Контейнеры панели (метка cloudserver.managed=true) панель ведёт сама. Ваши она только показывает и трогает лишь по вашему подтверждению.",
      "none": "Контейнеров нет.",
      "engineDown": "Docker не работает — контейнеры не видны.",
      "columns": {
        "name": "Контейнер",
        "state": "Состояние",
        "image": "Образ",
        "status": "Статус",
        "ports": "Порты"
      },
      "logs": "Журнал",
      "restart": "Перезапустить",
      "restartCustomer": "Перезапустить ваш контейнер",
      "more": "Показаны первые 50, ещё {{count}} — по кнопке «Показать все».",
      "showAll": "Показать все ({{count}})"
    },
    "logs": {
      "title": "Журнал: {{name}}",
      "lead": "Последние строки. Пароли, токены и ключи в них скрыты.",
      "empty": "Журнал пуст."
    },
    "restart": {
      "title": "Перезапустить {{name}}?",
      "lead": "Контейнер панели перезапустится; на это время он не отвечает.",
      "customer": "Это ваш контейнер: панель им не управляет и перезапускает его только по вашему подтверждению.",
      "downtime": "На время перезапуска контейнер не отвечает.",
      "done": "{{name}} перезапущен"
    },
    "images": {
      "title": "Неиспользуемые образы",
      "lead": "Образов, которые не использует ни один контейнер: {{count}}.",
      "none": "Все образы используются контейнерами.",
      "prune": "Удалить неиспользуемые образы",
      "pruneTitle": "Удалить неиспользуемые образы ({{count}})?",
      "pruneCustomer": "Удаляются и ваши образы: всё, что не использует ни один контейнер. Чтобы вернуть, их придётся скачать или собрать заново.",
      "pruneExact": "Удаляются ровно образы из списка ниже. Если список на сервере изменился, ничего не удалится.",
      "whatGoes": "Что удалится",
      "andMore": "и ещё {{count}}",
      "pruned": "Удалено образов: {{count}}"
    },
    "logsPending": "Настройки журналов ещё не действуют",
    "logsPendingText": "В /etc/docker/daemon.json записана ротация логов ({{size}}, файлов: {{files}}), но Docker с тех пор не перезапускался и работает с прежними настройками. Они вступят в силу при следующем запуске Docker или после перезапуска — он остановит работающие контейнеры без live-restore ({{count}}). Действуют только для новых контейнеров."
  },
  "connect": {
    "legend": "Как подключить",
    "kinds": {
      "secret": "Вставить ключ, созданный в консоли",
      "oauth": "Ключ выпустит панель по OAuth-клиенту организации",
      "device-login": "Войти по ссылке после установки"
    },
    "deviceAfter": "После установки на странице приложения появится ссылка для входа. Откройте её и войдите — панель сама увидит, что сервер подключился.",
    "connection": "Подключение организации",
    "noConnections": "В организации ещё нет подключений. Попросите администратора добавить OAuth-клиент Tailscale.",
    "noConnectionsAdmin": "В организации ещё нет подключений. Добавьте OAuth-клиент Tailscale.",
    "failing": "последний вызов не удался",
    "requiredInputs": "С этим способом обязательно заполнить: {{inputs}}.",
    "add": "Добавить подключение",
    "addTitle": "Новое подключение Tailscale",
    "addLead": "OAuth-клиент создаёт администратор сети в консоли Tailscale: Settings → OAuth clients, права auth_keys и devices:core. Панель проверит его и сохранит зашифрованным; секрет больше нигде не покажется.",
    "addSubmit": "Проверить и сохранить",
    "name": "Название",
    "clientId": "Client ID",
    "clientSecret": "Client secret",
    "clientSecretHint": "Начинается с tskey-client-. Хранится зашифрованным.",
    "loginTitle": "Вход в сеть",
    "loginLead": "Сервер ждёт, пока вы войдёте по ссылке.",
    "loginIdle": "Получите ссылку для входа. Не пересылайте её: кто первым войдёт по ней, в ту сеть и попадёт сервер.",
    "getLink": "Получить ссылку для входа",
    "openAndSignIn": "Откройте ссылку и войдите",
    "linkSecret": "Ссылка только для вас: не пересылайте её.",
    "waiting": "Ждём входа…",
    "expired": "Время вышло: вход не завершён. Получите новую ссылку.",
    "newLink": "Получить новую ссылку",
    "noLink": "Сервер не дал ссылку. Нажмите «Проверить» и попробуйте ещё раз."
  },
  "tailscale": {
    "noStatus": "Состояние Tailscale ещё не прочитано. Нажмите «Проверить».",
    "states": {
      "running": "Подключён",
      "starting": "Подключается",
      "needs_login": "Нужен вход",
      "needs_approval": "Ждёт одобрения",
      "stopped": "Остановлен вручную",
      "absent": "Не установлен",
      "unknown": "Не отвечает"
    },
    "tailnet": "Сеть {{name}}",
    "reconnect": "Переподключить",
    "logout": "Выйти из сети Tailscale",
    "signedOut": "Сервер вышел из сети Tailscale",
    "loginErrors": {
      "auth_key_expired": "Ключ авторизации истёк",
      "auth_key_invalid": "Ключ авторизации не подошёл: неверный или уже использован",
      "login_failed": "Войти в сеть Tailscale не удалось"
    },
    "reconnectOauth": "Нажмите «Переподключить» — панель выпустит новый ключ по OAuth-клиенту.",
    "reconnectKey": "Создайте новый ключ в консоли Tailscale и нажмите «Переподключить», чтобы его вставить.",
    "keysPage": "Ключи в консоли Tailscale",
    "needsApproval": "Сеть требует одобрять новые устройства: администратор одобряет сервер в консоли Tailscale (Machines).",
    "stopped": "Кто-то выполнил tailscale down на сервере. «Вернуть как было» снова подключит его.",
    "sshWarning": "Tailscale SSH включён: это второй путь на сервер в обход ваших ключей SSH и межсетевого экрана. Доступ решают правила ACL сети.",
    "tagsPending": "Новые теги применятся при переподключении.",
    "routes": {
      "title": "Маршруты",
      "lead": "Что узел объявляет и что одобрил администратор сети.",
      "approved": "одобрен",
      "pending": "ждёт одобрения",
      "exitNode": "Выходной узел",
      "howToApprove": "Одобрите в консоли администратора Tailscale: Machines → этот узел → «…» → Edit route settings — отметьте подсети и «Use as exit node». Или задайте autoApprovers в политике сети.",
      "console": "Открыть Machines в консоли Tailscale",
      "forwardingOff": "Пересылка IP на сервере выключена: маршруты и выходной узел не работают. «Вернуть как было» включит её."
    },
    "logoutTitle": "Выйти из сети Tailscale?",
    "logoutAccess": "Доступ к серверу через Tailscale пропадёт сразу.",
    "logoutAgain": "Вернуться можно через «Переподключить» с новым ключом или ссылкой.",
    "loggedOut": "Сервер вышел из сети Tailscale",
    "reconnected": "Переподключение выполнено",
    "reconnectLead": {
      "secret": "Вставьте новый ключ авторизации из консоли Tailscale.",
      "oauth": "Панель выпустит новый одноразовый ключ по OAuth-клиенту организации с тегами узла.",
      "device-login": "Сервер начнёт вход заново; затем получите новую ссылку для входа."
    },
    "devices": {
      "title": "Устройства сети",
      "lead": "Как их видит OAuth-клиент организации: адреса, когда были в сети, одобренные маршруты.",
      "show": "Показать устройства",
      "none": "В сети нет устройств.",
      "self": "этот сервер",
      "online": "в сети",
      "columns": {
        "name": "Имя",
        "addresses": "Адреса",
        "os": "Система",
        "seen": "Был в сети",
        "routes": "Подсети"
      }
    }
  },
  "resources": {
    "title": "Ресурсы",
    "lead": "Что приложение создало в вашем проекте у провайдера. Сейчас это стоит {{monthly}} в месяц.",
    "planning": "Считаем, что будет создано…",
    "planLead": "Приложение создаст в вашем проекте сервер — управляемый прибор: без вашего SSH-ключа, с защитой от удаления и с Автопилотом для управления приложением. Провайдер выставляет за него счёт, как за любой ваш сервер.",
    "planLabel": "Что будет создано",
    "kinds": {
      "server": "Сервер",
      "firewall": "Файрвол"
    },
    "ipv4": "IPv4",
    "free": "Бесплатно",
    "unpriced": "Цена неизвестна",
    "price": "{{monthly}} в месяц · {{hourly}} в час",
    "totalProvider": "Серверы у провайдера",
    "totalPackage": "Само приложение",
    "unpricedNote": "Для части ресурсов в прайс-листе нет цены: они посчитаны как бесплатные.",
    "costNote": "Это наша оценка по прайс-листу без НДС. Каждый начатый час оплачивается, но не больше месячной цены.",
    "provisioning": "Прибор создаётся: сервер, защита от удаления, Автопилот, затем само приложение. Обычно это занимает несколько минут.",
    "removing": "Прибор удаляется: защита снимается, сервер и его файрвол удаляются у провайдера.",
    "rolledBack": "Установка не удалась: {{reason}}. Всё, что успело создаться, удалено.",
    "noServerYet": "сервер прибора создаётся",
    "applianceOf": "Управляемый прибор · {{title}}",
    "since": "с {{time}}",
    "states": {
      "planned": "ждёт создания",
      "creating": "создаётся",
      "protecting": "включается защита",
      "enrolling": "ждём Автопилот",
      "ready": "работает",
      "unprotecting": "снимается защита",
      "deleting": "удаляется",
      "deleted": "удалён",
      "failed": "ошибка",
      "released": "ваш"
    },
    "drift": {
      "title": "Изменено у провайдера",
      "label": "Метка {{expected}} снята или изменена (сейчас: {{actual}})",
      "protection": "Защита от удаления и пересоздания выключена (включено: {{actual}})",
      "type": "Тип сервера сменён: {{actual}} вместо {{expected}}"
    },
    "restore": "Вернуть как было",
    "restored": "Прибор возвращается как было",
    "takeOver": "Забрать себе",
    "takeOverTitle": "Забрать себе {{name}}?",
    "takeOverKey": "Ваш SSH-ключ будет добавлен для root на этом сервере — через Автопилот.",
    "takeOverLabels": "Метки панели и защита от удаления и пересоздания будут сняты; сервер станет обычным вашим сервером.",
    "takeOverSupport": "Панель перестанет управлять этим сервером: ручные изменения больше не перезаписываются, а поддержка прибора заканчивается. Вернуть это нельзя.",
    "takeOverCost": "Сервер продолжит работать и оплачиваться как ваш.",
    "takeOverKeyLabel": "Какой ключ добавить",
    "takenOver": "{{name}} теперь ваш",
    "takenOverNotice": "Этот прибор забран себе: его сервер теперь ваш, панель им не управляет.",
    "noKeys": "В проекте нет SSH-ключей.",
    "addKey": "Добавить ключ",
    "removeServers": "Серверы прибора будут удалены у провайдера вместе с данными на них: {{names}}.",
    "removeCost": "Их оплата прекратится с удалением.",
    "removeStarted": "«{{name}}» удаляется вместе с сервером"
  }
}
